

















































































































import Vue, { PropType } from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";

interface UseStartingUrlProps {
  lang: any;
  supportUrl: string;
  volumeLicensesId: string;
  useStartingUrl: string;
}

interface UseStartingUrlData {
  isLoading: boolean;
  showModal: boolean;
  currentUseStartingUrl: string;
  showIssuingNewUrlModal: boolean;
  showModalInvalidationUrl: boolean;
  isShowTooltip: boolean;
}

export default Vue.extend({
  name: "vc-use-starting-url",
  props: {
    lang: {
      type: Object as PropType<UseStartingUrlProps["lang"]>,
      default: () => {},
    },
    supportUrl: {
      type: String as PropType<UseStartingUrlProps["supportUrl"]>,
      default: "",
    },
    volumeLicenseId: {
      type: String as PropType<UseStartingUrlProps["volumeLicensesId"]>,
      default: "",
    },
    useStartingUrl: {
      type: String as PropType<UseStartingUrlProps["useStartingUrl"]>,
      default: "",
    },
  },
  data(): UseStartingUrlData {
    return {
      isLoading: false,
      showModal: false,
      currentUseStartingUrl: this.useStartingUrl,
      showIssuingNewUrlModal: false,
      showModalInvalidationUrl: false,
      isShowTooltip: false,
    };
  },
  computed: {
    ...mapGetters("useStartingUrl", ["getUseStartingUrl"]),
    ...mapGetters("adminMessage", ["getAdminMessage"]),
    hasAdminMessage(): boolean {
      return !!this.getAdminMessage;
    },
    hasUseStartingUrl(): boolean {
      return !!this.currentUseStartingUrl;
    },
    urlDisplayValue(): string {
      return (
        this.currentUseStartingUrl ||
        (this.hasAdminMessage
          ? this.lang.paint_usage_start_url_placeholder_before_issuing_new_url
          : this.lang.paint_usage_start_url_placeholder)
      );
    },
  },
  methods: {
    ...mapActions("common", ["createNotification", "createErrorNotification"]),
    ...mapActions("useStartingUrl", [
      "deleteUseStartingUrl",
      "postUseStartingUrl",
    ]),
    ...mapMutations("useStartingUrl", ["updateVolumeLicenseId"]),
    getUseStartingUrlMessage() {
      if (this.currentUseStartingUrl) {
        let replacedText =
          this.lang.paint_usage_start_url_placeholder_after_issuing_new_url;
        replacedText = replacedText.replace(/:br/g, "\n");
        replacedText = replacedText.replace(
          /:url/g,
          this.currentUseStartingUrl
        );
        replacedText = replacedText.replace(/&amp;/g, "&");
        return replacedText;
      } else {
        return this.urlDisplayValue;
      }
    },
    async issuingNewUrl() {
      this.openModal();
      this.isLoading = true;
      this.updateVolumeLicenseId(this.volumeLicenseId);
      try {
        await this.postUseStartingUrl();
        this.currentUseStartingUrl = this.getUseStartingUrl;
        this.createNotification({
          label: this.lang.issuing_new_url_success,
          style: "is-success",
        });
      } catch {
        this.createErrorNotification({
          label: this.lang.issuing_new_url_error_alert,
          style: "is-danger",
          linkLabel: this.lang.link_in_description,
          link: this.supportUrl,
        });
      }
      this.isLoading = false;
      this.closeModal();
    },
    async invalidationUrl() {
      this.openModal();
      this.isLoading = true;
      this.updateVolumeLicenseId(this.volumeLicenseId);
      try {
        await this.deleteUseStartingUrl();
        this.currentUseStartingUrl = this.getUseStartingUrl;
        this.createNotification({
          label: this.lang.invalidation_success,
          style: "is-dark",
        });
      } catch {
        this.createErrorNotification({
          label: this.lang.invalidation_error_alert,
          style: "is-danger",
          linkLabel: this.lang.link_in_description,
          link: this.supportUrl,
        });
      }
      this.isLoading = false;
      this.closeModal();
    },
    copyUrl() {},
    openModalIssuingNewUrl() {
      this.openModal();
      this.showIssuingNewUrlModal = true;
      this.showModalInvalidationUrl = false;
    },
    openModalInvalidationUrl() {
      this.openModal();
      this.showIssuingNewUrlModal = false;
      this.showModalInvalidationUrl = true;
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    onClickCopy() {
      const input = document.createElement("textarea");
      input.value = this.getUseStartingUrlMessage();
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);

      this.isShowTooltip = true;
      setTimeout(() => {
        this.isShowTooltip = false;
      }, 5000);
    },
  },
});
